"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Person = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Avatar = _interopRequireWildcard(require("../Avatar"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _SIZE_TO_AVATAR_SIZE, _SIZE_TO_NAME_TYPOGRA, _SIZE_TO_SUBHEADING_T;

var SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
var SIZE_TO_AVATAR_SIZE = (_SIZE_TO_AVATAR_SIZE = {}, (0, _defineProperty2["default"])(_SIZE_TO_AVATAR_SIZE, SIZES.small, [_Avatar.AvatarSize.Small]), (0, _defineProperty2["default"])(_SIZE_TO_AVATAR_SIZE, SIZES.medium, [_Avatar.AvatarSize.Medium]), (0, _defineProperty2["default"])(_SIZE_TO_AVATAR_SIZE, SIZES.large, [_Avatar.AvatarSize.Large]), _SIZE_TO_AVATAR_SIZE);
var SIZE_TO_NAME_TYPOGRAPHY_VARIANT = (_SIZE_TO_NAME_TYPOGRA = {}, (0, _defineProperty2["default"])(_SIZE_TO_NAME_TYPOGRA, SIZES.small, 'subtitle2'), (0, _defineProperty2["default"])(_SIZE_TO_NAME_TYPOGRA, SIZES.medium, 'subtitle2'), (0, _defineProperty2["default"])(_SIZE_TO_NAME_TYPOGRA, SIZES.large, 'h6'), _SIZE_TO_NAME_TYPOGRA);
var SIZE_TO_SUBHEADING_TYPOGRAPHY_VARIANT = (_SIZE_TO_SUBHEADING_T = {}, (0, _defineProperty2["default"])(_SIZE_TO_SUBHEADING_T, SIZES.small, 'caption'), (0, _defineProperty2["default"])(_SIZE_TO_SUBHEADING_T, SIZES.medium, 'caption'), (0, _defineProperty2["default"])(_SIZE_TO_SUBHEADING_T, SIZES.large, 'body1'), _SIZE_TO_SUBHEADING_T);

var Person = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Person, _PureComponent);

  var _super = (0, _createSuper2["default"])(Person);

  function Person() {
    (0, _classCallCheck2["default"])(this, Person);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Person, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          subheading = _this$props.subheading,
          profileImage = _this$props.profileImage,
          missingNameString = _this$props.missingNameString,
          avatarBackgroundColor = _this$props.avatarBackgroundColor,
          size = _this$props.size;
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 2,
        alignItems: "center",
        wrap: "nowrap"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
        id: "".concat(id, "-person-avatar"),
        alt: "profile image for ".concat(name),
        src: profileImage,
        backgroundColor: avatarBackgroundColor,
        size: SIZE_TO_AVATAR_SIZE[size]
      }, name ? name.substring(0, 2) : null, !name && subheading ? subheading.substring(0, 2) : null)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        container: true,
        direction: "column",
        zeroMinWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        container: true,
        zeroMinWidth: true
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: SIZE_TO_NAME_TYPOGRAPHY_VARIANT[size],
        noWrap: true
      }, name || /*#__PURE__*/_react["default"].createElement("i", null, missingNameString))), subheading && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        color: "textSecondary",
        variant: SIZE_TO_SUBHEADING_TYPOGRAPHY_VARIANT[size]
      }, subheading))));
    }
  }]);
  return Person;
}(_react.PureComponent);

exports.Person = Person;
Person.defaultProps = {
  profileImage: null,
  name: null,
  subheading: null,
  avatarBackgroundColor: null,
  size: SIZES.medium
};
var _default = Person;
exports["default"] = _default;